// @flow

export const UPGRADE_BASE_URL = '/app/billing/plans/upgrade';
export const EVENT_TRACK_TRIAL_BANNER = 'Trial: clicked banner';
